//vendor
import $ from 'jquery';
import Player from '@vimeo/player';
import Helper from '../helpers/util';
//import Component from '../classes/component';

class VideoVimeo {
	constructor(el) {

		this.options = {
			dataVimeoAttribute : 'data-id-vimeo',
			videoThumbSelector: '.video-thumb',
			videoInfoTitleSelector: '.video-info-title',
			videoInfoTimeSelector: '.video-info-time',
			videoPreviewSelector: '.video-preview',
			isHiddenClass: 'is-hidden'
		};

		this.el = el;
		this.$el = $(el);

		this.idVideo = this.$el.attr(this.options.dataVimeoAttribute);
		this.$image = this.$el.find(this.options.videoThumbSelector);
		this.$title = this.$el.find(this.options.videoInfoTitleSelector);
		this.$time = this.$el.find(this.options.videoInfoTimeSelector);
		this.$preview = this.$el.find(this.options.videoPreviewSelector);

		console.log(this.idVideo);

		this.getVideoFromId();
		this.attachEvents();
		this.$el.data('init', true);
	}

	getVideoFromId() {

		$.ajax({
			type:'GET',
			url: 'http://vimeo.com/api/v2/video/' + this.idVideo + '.json',
			jsonp: 'callback',
			dataType: 'jsonp',
			success: (data) => {
				const videoItem = data[0];
				const min =  Math.floor(videoItem.duration/60);
				const sec = videoItem.duration - min * 60;
				const timing = min + ':' + sec;

				// this.$image.attr('style', `background-image: url('${videoItem.thumbnail_large}')`);
				this.$title.text(videoItem.title);
				this.$time.text(timing);
			}
		});

	}

	attachEvents() {

		this.$preview.on('click', (e) => {
			e.preventDefault();
			let player = new Player(this.el, {
				id: parseInt(this.idVideo),
				width: 640
			});

			player.play();

			this.$preview.addClass(this.options.isHiddenClass);
		});

	}

}

const _init = () => {
	//Elements
	let $el = $('.video-player');
	if ($el.length) {
		$el.each((i, v) => {
			if ( !$(v).data('init') ) {
				new VideoVimeo(v);
			}
		});
	}
};

_init();
Helper.pubsub.subscribe('initComponents', function(){
	_init();
});
